module.exports = __webpack_public_path__ + "static/media/Group 1000006631.5b229832.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/Group 1000006631.png
// module id = 1206
// module chunks = 0